import { Autocomplete, Box, Button, Chip, TextField } from "@mui/material";
import React, { useState } from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import {
  CancelButton,
  UpdateButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { useSelector, useDispatch } from "react-redux";
import useHandleApiResponse from "../../../../../Hooks/useHandleApiResponse";
import {
  changeReviewer,
  getCycleAssignedUsers,
} from "../../../../../redux/features/appraisalSlice";
const userData = [
  { userId: 1, name: "John Doe" },
  { userId: 2, name: "Jane Smith" },
  { userId: 3, name: "Alice Johnson" },
  { userId: 4, name: "Bob Williams" },
];

const ChangeReviewer = ({ cycleId, userId }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [selectedUserIds, setSelectedUser] = useState(null);
  const { allUsers } = useSelector((state) => state.general);
  const { loading } = useSelector((state) => state.appraisal);

  const handleChange = (event, newValue) => {
    if (newValue) {
      setSelectedUser(newValue);
    } else {
      setSelectedUser(null);
    }
  };
  const handleApiResponse = useHandleApiResponse();
  const handleChangeReviewer = () => {
    const data = {
      id: cycleId,
      managerId: selectedUserIds.userID,
      userId: userId,
    };
    dispatch(changeReviewer(data)).then((res) => {
      handleApiResponse(res, {
        onSuccess: () => {
          setOpen(false);
          dispatch(getCycleAssignedUsers(cycleId));
        },
        onFailed: () => {
          console.log("Something went wrong");
        },
      });
    });
  };
  return (
    <Box>
      <GlobalDialog
        open={open}
        setOpen={setOpen}
        title={"Change Reviewer"}
        closeButton={true}
        fullWidth
        maxWidth={"xs"}
        popupButton={
          <Button
            sx={{ borderRadius: 3 }}
            size="small"
            variant="outlined"
            onClick={() => setOpen(true)}
          >
            Change Reviewer
          </Button>
        }
        content={
          <>
            <Box>
              <Autocomplete
                options={allUsers}
                getOptionLabel={(option) => option.name}
                onChange={handleChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select User"
                    placeholder="Choose..."
                  />
                )}
              />
            </Box>
          </>
        }
        actionButton={
          <>
            <CancelButton action={() => setOpen(false)} size={"small"}>
              Cancel
            </CancelButton>
            <UpdateButton
              disabled={loading}
              action={handleChangeReviewer}
              size={"small"}
            >
              {loading ? "Please wait..." : "Update"}
            </UpdateButton>
          </>
        }
      />
    </Box>
  );
};

export default ChangeReviewer;
